import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppBar, Box, Grid, Tabs, Tab, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'lodash';
import dayjs from 'dayjs';
import TabPanel from '../common/tabpanel';

export default function Surveys(props) {
    // surveys in state is a map keyed by id; convert to an array for listing
    const surveysMap = useSelector((state) => state.surveydata.surveys);
    const [surveys, setSurveys] = useState(null);
    const [openSurveys, setOpenSurveys] = useState([]);
    const [closedSurveys, setClosedSurveys] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        if (surveysMap) {
            setSurveys(Object.values(surveysMap));
        }
    }, [surveysMap]);

    useEffect(() => {
        if (surveys && surveys.length > 0) {
            const sortedSurveys = orderBy(surveys, ['updateDate'], ['desc']);
            setClosedSurveys(sortedSurveys.filter((s) => s.status === 1));
            setOpenSurveys(sortedSurveys.filter((s) => s.status === 0));
        } else {
            setClosedSurveys([]);
            setOpenSurveys([]);
        }
        if (window.location.hash === '#completed') {
            setActiveTab(1);
        }
    }, [surveys]);

    const openSurvey = (id) => {
        props.history.push('/survey/' + id);
    };

    const onTabChange = (event, selectedTab) => {
        setActiveTab(selectedTab);
        props.history.push(selectedTab === 0 ? '/surveys' : '/surveys#completed');
    };

    if (!surveys || surveys.length === 0) {
        return (
            <Grid container>
                <Grid item xs={12}>
                    {t('survey.noSurveys')}
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container>
            <AppBar position="static" color="default">
                <Box display="flex" justifyContent="center" width="100%">
                    <Tabs
                        value={activeTab}
                        onChange={onTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto">
                        <Tab
                            value={0}
                            label={`${t('survey.uncompletedSurveys')} (${openSurveys.length})`}
                            name="tab-open-sruveys"
                        />
                        <Tab
                            value={1}
                            label={`${t('survey.completedSurveys')} (${closedSurveys.length})`}
                            name="tab-closed-surveys"
                        />
                    </Tabs>
                </Box>
            </AppBar>
            <TabPanel value={activeTab} index={0} sx={{ width: '99%' }}>
                <Grid container>
                    {openSurveys.map((survey) => (
                        <Grid item xs={12} key={survey.id}>
                            <Box
                                onClick={() => openSurvey(survey.id)}
                                sx={{
                                    border: '1px solid #ccc',
                                    margin: '5px 0',
                                    padding: '10px',
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <h3>{survey.name}</h3>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body2" color="textSecondary">
                                            {t('survey.modifiedAt', {
                                                timeStamp: dayjs
                                                    .utc(survey.updateDate)
                                                    .local()
                                                    .format('DD.MM.YYYY HH:mm'),
                                            })}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </TabPanel>
            <TabPanel value={activeTab} index={1} sx={{ width: '99%' }}>
                <Grid container>
                    {closedSurveys.map((survey) => (
                        <Grid item xs={12} key={survey.id}>
                            <Box
                                onClick={() => openSurvey(survey.id)}
                                sx={{
                                    border: '1px solid #ccc',
                                    margin: '5px 0',
                                    padding: '10px',
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <h3>{survey.name}</h3>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body2" color="textSecondary">
                                            {t('survey.modifiedAt', {
                                                timeStamp: dayjs
                                                    .utc(survey.updateDate)
                                                    .local()
                                                    .format('DD.MM.YYYY HH:mm'),
                                            })}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </TabPanel>
        </Grid>
    );
}
